import moment from "moment";
import { Moment } from "moment";
import { Rolling, SurveyType, Uptime, warranty } from "../../../services/payload/models/periodAndSurveyType";

export interface IPeriodAndSurveyTypeFilters  {
  rolling: Rolling;
  month: Moment,
  surveyTypes: SurveyType[],
  warranties: warranty[],
  uptimes: Uptime[]
}
export class PeriodAndSurveyTypeFilters implements IPeriodAndSurveyTypeFilters {
  rolling: Rolling = 'ONE_MONTH';
  month: Moment = moment();
  surveyTypes: SurveyType[] = [];
  warranties: warranty[] = [];
  uptimes: Uptime[] = [];

  constructor() { }
}
